import { render } from "./RegulationPage.vue?vue&type=template&id=08194974&scoped=true"
import script from "./RegulationPage.vue?vue&type=script&lang=js"
export * from "./RegulationPage.vue?vue&type=script&lang=js"

import "./RegulationPage.vue?vue&type=style&index=0&id=08194974&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08194974"]])

export default __exports__